import { Key, KeyGetter, ItemValue } from './types'

export const { isArray } = Array
export const toArray = (value: any): any[] => (isArray(value) ? value : [value])
export const defaultKeyGetter = (v: any) => v
export const isUndefined = (value: any): value is undefined => typeof value === 'undefined'
export const isEmpty = (value: any): value is (undefined | null) => (isUndefined(value) || value === null)

export function getKey<T = ItemValue>(
  keyGetter: KeyGetter<T>,
  value: T | null
): Key {
  if (!isEmpty(value)) {
    const key = (keyGetter || defaultKeyGetter)(value)

    if (!isUndefined(key)) {
      return key
    }

    return value
  }

  return null
}
